import { Gradients } from '@picsart/design-system/foundation/colors';
import { FontSizes, LineHeights } from '@picsart/design-system/foundation/typography';

import { FontWeights } from '@picsart/design-system/foundation/fonts';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { createUseStyles } from 'react-jss';

import { BreakPointsMedia } from '@picsart/design-system/foundation/responsive';
import { EmbeddedVideoProps } from 'redesignedComponents/sections/EmbeddedVideo/types';

const useStyles = createUseStyles<
  string,
  {
    titleColor?: string;
    videoBgColor?: string;
    embed?: EmbeddedVideoProps;
    videoMaxWidth?: string | number;
    isMaximizer?: boolean;
  }
>(
  {
    root: {
      display: 'flex',
      flexDirection: 'column',
      margin: [Spacings.s0, 'auto'],
      alignItems: 'center',
    },
    content: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      margin: [Spacings.s0, 'auto'],
      padding: [Spacings.s32, Spacings.s0, Spacings.s40],
      width: '100%',

      // [mediaQuery(OldBreakPoints.small)]: {
      '@media screen and (max-width: 768px)': {
        order: 1,
        padding: [Spacings.s32, Spacings.s0, Spacings.s0],
      },
    },
    video: {
      '&&': {
        display: 'block',
        margin: [Spacings.s0, 'auto'],
        maxWidth: p => p.videoMaxWidth || 940,
        width: '100%',
        aspectRatio: '16 / 9',

        '@media screen and (max-width: 768px)': {
          margin: [Spacings.s24, 'auto', Spacings.s24],
          order: 2,
          aspectRatio: ({ embed }) => !embed && '5 / 4',
        },
      },
    },
    embed: {
      '&&': {
        display: 'block',
        margin: [Spacings.s0, 'auto'],
        maxWidth: p => p.embed?.maxWidth || 940,
        width: '100%',
        aspectRatio: '16 / 9',

        '@media screen and (max-width: 768px)': {
          margin: [Spacings.s24, 'auto', Spacings.s24],
          order: 2,
          aspectRatio: ({ embed }) => !embed && '5 / 4',
        },
      },
    },
    media: {
      '&&': {
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        height: '100%',
        '& > div': {
          width: '100%',
          '& img': {
            '@media screen and (max-width: 768px)': {
              height: isMaximizer => (isMaximizer ? 'auto' : 140),
            },
          },
        },
      },
    },
    titleCon: {
      margin: [Spacings.s24, 'auto', Spacings.s24],

      [BreakPointsMedia.LG]: {
        maxWidth: 1200,
      },
      [BreakPointsMedia.MD]: {
        maxWidth: 960,
      },
      [BreakPointsMedia.SM]: {
        maxWidth: 960,
      },
      [BreakPointsMedia.XS]: {
        maxWidth: 960,
      },
      [BreakPointsMedia.XXS]: {
        maxWidth: 960,
      },

      '@media screen and (max-width: 766px)': {
        minHeight: 50,
      },

      '@media screen and (max-width: 768px)': {
        margin: [Spacings.s24, 'auto', Spacings.s16],
      },

      '@media screen and (max-width: 576px)': {
        minHeight: 100,
      },
    },
    title: {
      textAlign: 'center',

      '& i': {
        fontStyle: 'normal',
        backgroundClip: 'text',
        '-webkit-background-clip': 'text',
        '-webkit-text-fill-color': 'transparent',
        background: Gradients.pro,
      },
    },
    descriptionCon: {
      minHeight: 56,
      marginBottom: Spacings.s24,

      '@media screen and (max-width: 560px)': {
        minHeight: 72,
      },
    },
    description: {
      display: 'block',
      fontSize: FontSizes.s20,
      fontWeight: FontWeights.medium,
      lineHeight: LineHeights.l28,
      textAlign: 'center',
      padding: [Spacings.s0, Spacings.s64],
      maxWidth: 770,

      '@media screen and (max-width: 480px)': {
        padding: Spacings.s0,
      },
    },
    videoWrapper: {
      backgroundColor: ({ videoBgColor }) => videoBgColor,
      padding: Spacings.s16,

      '@media screen and (max-width: 768px)': {
        padding: Spacings.s2,
        marginTop: Spacings.s24,
      },
    },
    // SKELETON
    choicesSK: {
      aspectRatio: '5.3',
    },
    descriptionSK: {
      height: 56,
      maxWidth: 642,
    },
    buttonSK: {
      maxWidth: 236,
      aspectRatio: 5,
    },
    mediaSK: {
      aspectRatio: '16 / 9',

      '@media screen and (max-width: 768px)': {
        aspectRatio: '5 / 4',
      },
    },
  },
  {
    name: 'home-top-section',
  },
);

export default useStyles;
